import { render } from "./KreditView.vue?vue&type=template&id=56896500"
import script from "./KreditView.vue?vue&type=script&lang=js"
export * from "./KreditView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__